<template>
  <div class="text-body-container">
    <BContainer>
      <BRow class="justify-content-center">
        <BCol md="8" cols="12">
          <div :key="key" v-for="(el, key) in text">
            <div :key="`${type}_${key}`" v-for="(content, type) in el">
              <div v-html="content" v-if="type==`text`"></div>
              <TextLongItem :text="content" v-if="type==`text_long`" />
              <RawInline :src="content" v-if="type==`raw`" />
              <RawInteractive :src="content" v-if="type==`raw_interactive`" />
              <ImageInline :src="content" v-if="type==`photo`" />
              <ImageInlineMobile :src="content" v-if="type==`photo_scroll_mobile`" />
              <ImageInlineScroll :src="content" v-if="type==`photo_scroll`" />
              <VideoInline :src="content" v-if="type==`video`" />
              <VideoScrollMobile :src="content" v-if="type==`video_scroll_mobile`" />
              <VideoInlineScroll :src="content" v-if="type==`video_scroll`" />
              <VideoInlineScrollLong :src="content" v-if="type==`video_scroll_long`" />
              <ImageGallery v-if="type==`photo_gallery`" :items="content"/>
            </div>
          </div>
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>

<style lang="scss">

  .text-body-container {
    padding: 15px 0;
    font-size: 18px;

    img {
      width: 100%;
    }
  }

</style>

<script>

  import RawInteractive from '@/components/RawInteractive'
  import RawInline from '@/components/RawInline'
  import ImageInline from '@/components/ImageInline'
  import ImageInlineMobile from '@/components/ImageInlineMobile'
  import ImageInlineScroll from '@/components/ImageInlineScroll'
  import VideoInline from '@/components/VideoInline'
  import VideoInlineScroll from '@/components/VideoInlineScroll'
  import VideoScrollMobile from '@/components/VideoScrollMobile'
  import VideoInlineScrollLong from '@/components/VideoInlineScrollLong'
  import ImageGallery from '@/components/ImageGallery'
  import TextLongItem from '@/components/TextLongItem'

  export default {
    name: 'TextBody',
    props: {
      text: Array
    },
    components: {
      TextLongItem,
      RawInteractive,
      RawInline,
      ImageInline,
      ImageGallery,
      ImageInlineMobile,
      ImageInlineScroll,
      VideoInline,
      VideoScrollMobile,
      VideoInlineScroll,
      VideoInlineScrollLong
    }
  }
</script>